<template>
    <div class="bg-gray-125 dark:bg-gray-785 border-t border-gray-250 dark:border-gray-650 -mx-4 at1024:bg-transparent at1024:border-t-0 at1024:mt-10 at1024:mx-0 at1024:px-0">
        <h2 class="font-medium text-lg">
            <button @click="isOpen = !isOpen" class="px-4 at1024:px-0 duration-75 active:bg-gray-tier-6 at1024:mb-4 flex items-center justify-between py-3 w-full at1024:pointer-events-none at1024:py-0">
                <slot name="title" />
                <BaseSvg :name="isOpen ? 'ExpandLess': 'ExpandMore'" class="block at1024:hidden" aria-hidden="true" />
            </button>
        </h2>
        <div :class="isOpen ? 'block mt-4 at1024:mt-0' : 'hidden at1024:block'" class="pb-10 at1024:pb-5 px-4 at1024:px-0">
            <slot name="default" />
        </div>
    </div>
</template>

<script setup>
import {BaseSvg} from "@/Components";
import {ref} from "vue";

const isOpen = ref(false);
</script>
